<template>
  <!-- 保单详情 -->
  <dialogWrap
      v-model="isShow"
      title="违章处理详情"
      :width="'824px'"
    >
      <template>
        <el-form>
          <column-box
            :column="2"
            :source="source"
            :list="list"
            :labelWidth="130"
          >
          </column-box>
        </el-form>
      </template>
    </dialogWrap>
</template>
<script>
import selectOption from '@/store/dict/selectOptionDict'
import config from '../config/violationDetail'

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShow: false,
      list: config.call(this).list,
    }
  },
  watch: {
    source() {
      this.dealKey()
    },
  },
  methods: {
  // 处理显示字段
    dealKey() {
      const { handleState, paymentState, dealViolationWay } = this.source
      this.source.handleState = selectOption.processingstatusDict[handleState]
      this.source.paymentState = selectOption.paymentStateList[paymentState]
      this.source.dealViolationWay = selectOption.dealViolationWayList[dealViolationWay]
    },
  },
}
</script>
<style lang="scss" scoped>
.alone ::v-deep .el-form-item__content {
margin-left: 0 !important;
}
</style>
